<script>
import CustomerList from '@app/components/CustomerList.vue';
import CustomerExportForm from '@app/components/CustomerExportForm.vue';

export default {
  name: 'Customers',
  components: { CustomerList, CustomerExportForm },
  head: {
    title: 'Apprenants',
  },
  data: () => ({ isExportingModalOpen: false, isExporting: false }),
  computed: {
    store() {
      return this.$store.getters['auth/store'];
    },
  },
};
</script>

<template>
  <div>
    <div
      v-if="store.has_disabled_customers && store.capabilities.nb_customers !== -1"
      class="box is-danger content"
    >
      <p>
        <b-icon icon="exclamation-triangle" class="has-text-black mr-3" />
        <strong>Accès bloqué pour certains apprenants</strong> :
        le <span v-t="`packs.${store.plan}`" /> limite l'accès à
        {{ store.capabilities.nb_customers }} apprenants.
        Mettez à jour votre offre pour rétablir l'accès.
      </p>
    </div>
    <div class="level is-mobile">
      <div class="level-left">
        <h1 class="title is-size-4-mobile">
          Apprenants
        </h1>
      </div>
      <div class="level-right">
        <b-tooltip label="Compatible Excel &amp; Google Sheet" position="is-left">
          <b-button type="is-primary" icon-left="file-export" @click="isExportingModalOpen = true" :loading="isExporting">
            Export CSV
          </b-button>
        </b-tooltip>
      </div>
    </div>
    <b-modal :width="460" :active.sync="isExportingModalOpen">
      <div class="box">
        <CustomerExportForm @done="isExportingModalOpen = false" />
      </div>
    </b-modal>

    <CustomerList />
  </div>
</template>
